import React from 'react';

const limitedLicenseRestrictions = [
  'Reproduce, distribute, publish, display, or transmit any content publicly or commercially.',
  'Modify, adapt, or create derivative works.',
  'Use content for training artificial intelligence models or data scraping.',
  'Share login credentials or redistribute content to non-subscribers.',
  'Remove any copyright, trademark, or other proprietary notices.',
];

const infringementDetails = [
  'A description of the copyrighted work.',
  'The location, URL, or description of the allegedly infringing material.',
  'Your contact information.',
  'A statement of good faith belief that the use is not authorized.',
  'A statement under penalty of perjury that the information is accurate and you are the owner or authorized to act.',
];

const CopyrightNotice: React.FC = () => {
  return (
    <main className="min-h-screen bg-white text-[#17243a]">
      <section className="border-b border-gray-200 bg-[#f7f6f1]">
        <div className="mx-auto px-4 md:px-10 lg:px-32 w-full py-16 lg:py-24">
          <p className="mb-4 text-sm font-semibold uppercase tracking-[0.28em] text-[#0B6054]">Legal</p>
          <h1 className="mb-5 text-4xl font-bold tracking-tight text-[#1a2942] sm:text-5xl lg:text-6xl">
            Copyright Notice
          </h1>
          <p className="text-lg font-semibold text-gray-700">© 2026 The Wealthy Miner LLC. All Rights Reserved.</p>
        </div>
      </section>

      <section className="mx-auto px-4 md:px-10 lg:px-32 w-full py-12 lg:py-16">
        <article className="prose prose-lg max-w-none prose-headings:text-[#1a2942] prose-p:text-gray-700 prose-li:text-gray-700">
          <p>
            All content available on thewealthyminer.com and through The Wealthy Miner subscription services, including but
            not limited to text, research reports, analysis, stock ideas, educational materials, videos (“Drill Bits” and
            others), images, graphics, logos, software, and community features, is the property of The Wealthy Miner LLC or its
            content licensors and is protected by United States and international copyright laws.
          </p>

          <section className="mt-10">
            <h2 className="mb-4 text-2xl font-bold">Limited License</h2>
            <p>
              Subject to your compliance with our Terms and Conditions and maintenance of an active subscription where
              required, The Wealthy Miner LLC grants you a limited, revocable, non-exclusive, non-transferable license to
              access and use the content solely for your personal, non-commercial purposes. This license does not include the
              right to:
            </p>
            <ul className="list-disc space-y-2 pl-6">
              {limitedLicenseRestrictions.map((restriction) => (
                <li key={restriction}>{restriction}</li>
              ))}
            </ul>
          </section>

          <section className="mt-10">
            <h2 className="mb-4 text-2xl font-bold">Trademarks</h2>
            <p>
              “The Wealthy Miner,” the associated logos, and other marks are trademarks of The Wealthy Miner LLC. You may not
              use them without prior written permission.
            </p>
          </section>

          <section className="mt-10">
            <h2 className="mb-4 text-2xl font-bold">User Content</h2>
            <p>
              Content you submit, including posts and comments, remains your property. By submitting it, you grant The Wealthy
              Miner LLC a perpetual, worldwide, royalty-free, sublicensable license to use, reproduce, modify, and display that
              content in connection with the Service.
            </p>
          </section>

          <section className="mt-10">
            <h2 className="mb-4 text-2xl font-bold">Reporting Infringement</h2>
            <p>If you believe any content on the Service infringes your copyright, please contact us with the following information:</p>
            <ul className="list-disc space-y-2 pl-6">
              {infringementDetails.map((detail) => (
                <li key={detail}>{detail}</li>
              ))}
            </ul>
            <p>
              Contact:{' '}
              <a
                href="mailto:info@thewealthyminer.com"
                className="font-medium text-[#0B6054] underline underline-offset-4 hover:text-[#c9a227]"
              >
                info@thewealthyminer.com
              </a>
            </p>
            <p>
              We will respond to valid notices in accordance with applicable law, including the U.S. Digital Millennium
              Copyright Act where it applies.
            </p>
          </section>

          <section className="mt-10">
            <h2 className="mb-4 text-2xl font-bold">Third-Party Content</h2>
            <p>
              The Service may contain links to third-party websites or content. We are not responsible for the copyright status
              or practices of those third parties.
            </p>
            <p>For permissions or licensing inquiries beyond the limited personal use described above, please contact us.</p>
          </section>

          <section className="mt-10 rounded-2xl border border-gray-200 bg-[#f7f6f1] p-6 sm:p-8">
            <h2 className="mb-4 text-2xl font-bold">Company Information</h2>
            <p className="mb-0">
              The Wealthy Miner LLC
              <br />
              A Wyoming limited liability company
              <br />
              Website: thewealthyminer.com
            </p>
          </section>
        </article>
      </section>
    </main>
  );
};

export default CopyrightNotice;
